import { CUSTOM_RESULT_KEYS, NOT_ASSIGNED } from 'constants/constants';
import React from 'react';
import { LcaCustomResultModel } from 'types/types';

import VersionHistorySummaryGrid, { SummaryGridRow } from '../VersionHistorySummaryGrid';
import { EpdVersionHistoryData, useEpdVersionHistoryData } from '../utils/EpdVersionHistoryDataContext';
import { ComparerRowsGetter } from '../../version-compare/VersionCompareKeyValueGrid';

type Props = {
  customResult: LcaCustomResultModel;
};

const VersionHistoryLcaCustomResultGrid: React.FC<Props> = ({ customResult }) => {
  const { scenarios } = useEpdVersionHistoryData();
  const rows = getCustomResultDescriptionRows({ scenarios } as EpdVersionHistoryData, true, customResult);
  return rows.length > 0 && <VersionHistorySummaryGrid rows={rows} />;
};

export default VersionHistoryLcaCustomResultGrid;

export const getCustomResultDescriptionRows: ComparerRowsGetter = (
  data: EpdVersionHistoryData,
  _: boolean,
  customResult: any
): SummaryGridRow[] => {
  const possibleRows: (SummaryGridRow | false)[] = [
    customResult?.resultType === CUSTOM_RESULT_KEYS.A4C4 && {
      ord: 0,
      name: 'Additional scenario',
      value: (() => {
        if (!customResult?.scenarioId) {
          return NOT_ASSIGNED;
        }
        const scenario = data.scenarios?.find((s) => s.id === customResult?.scenarioId);
        if (!scenario) {
          return NOT_ASSIGNED;
        }
        return scenario.name ?? NOT_ASSIGNED;
      })(),
    },
    customResult?.resultType === CUSTOM_RESULT_KEYS.BEST &&
      customResult?.bestCaseProduct != null && {
        ord: 1,
        name: 'Best-case product',
        value: customResult?.bestCaseProduct,
      },
    customResult?.resultType === CUSTOM_RESULT_KEYS.WORST &&
      customResult?.worstCaseProduct != null && {
        ord: 2,
        name: 'Worst-case product',
        value: customResult?.worstCaseProduct,
      },
    customResult?.scenarioDescription != null && {
      ord: 3,
      name: 'Description of the scenario/method',
      value: customResult?.scenarioDescription,
    },
  ];

  const rows = possibleRows.filter(Boolean) as SummaryGridRow[];
  return rows;
};
